export default "__VITE_ASSET__179a7cdd__"